import React from "react";
import DetailCard from "../DetailCard";
import girl from "../../../../assets/Khmergate/traveler-watching-sunset-ancient-temple-complex.jpg";
import strategic from "../../../../assets/strategic.jpg";
import girl_man from "../../../../assets/Khmergate/businessman-giving-his-boarding-pass-female-staff-check-desk.jpg";
import focused from "../../../../assets/focused.jpg";
import mic_img from "../../../../assets/Khmergate/laptop-with-microphone-screen-screen-with-words-sound-it.jpg";
import thai_girl from "../../../../assets/Khmergate/asia-woman-thai-dress-traditional-hold-kratong-loy-krathong-festival.jpg";
import couple from "../../../../assets/Khmergate/couple-is-walking-down-staircase-they-are-holding-hands.jpg";

import KhmergateFifthHeader from "./KhmergateFifthHeader";

const KhmergateFifth = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <KhmergateFifthHeader />
      <DetailCard
        image={girl}
        topicTop="Discover Cambodia"
        topicBottom=" with Our Inbound Tours   "
        description="Cambodia is a land of ancient wonders, vibrant traditions, and awe-inspiring landscapes. With KhmerGate's Inbound Tours, you can dive deep into the country's heritage while enjoying tailored experiences that cater to every traveler. "
        subTopic="Our Inbound Tour Offerings: "
        subPoint1="Cultural Immersion: "
        subPointDes1="Discover the heart and soul of Cambodia through guided visits to historical temples, local villages, and traditional workshops, offering you a true taste of Cambodian life. "
        subPoint2="Adventure and Eco-Tourism: "
        subPointDes2="Hike through pristine jungles, explore remote islands, or engage in eco-friendly tours that highlight Cambodia's stunning natural environment and commitment to sustainability. "
        subPoint3="Historic Landmarks: "
        subPointDes3="

Walk through history as you explore the legendary Angkor Wat, the bustling streets of Phnom Penh, and the many hidden treasures spread across the country."
        conclusion="Whether you're an adventurer, a history buff, or simply curious about Cambodian culture, our inbound tours are designed to offer authentic, immersive experiences. "
        imagePosition="right"
        buttonHoverColor="#927b49"
        buttoncolor="#ff6b18"
        textColor="#015B02"
      />
      <div className="h-[2px] w-3/4 bg-black"></div>
      <DetailCard
        image={girl_man}
        topicTop=" Air Ticketing: "
        topicBottom="Your Gateway to Seamless 
Travel"
        description="At KhmerGate, we believe that every journey begins with the 
perfect flight. Our Air Ticketing services are designed to 
simplify the booking process, offering you the best options for 
domestic and international travel. Whether you’re planning a 
solo adventure, a family vacation, or corporate travel, 
KhmerGate ensures a hassle-free experience from booking to 
boarding. "
        subTopic=" Our Air Ticketing Services Include: "
        subPoint1=" Domestic and International Flights:"
        subPointDes1="
Access 
competitive fares and a wide range of airlines for 
seamless travel across Cambodia and around the 
world. "
        subPoint2=" Tailored Travel Solutions: "
        subPointDes2=" We help you find flights 
that match your schedule, budget, and preferences, 
ensuring a personalized experience. "
        subPoint3=" Group Bookings: "
        subPointDes3="
From flights and hotels to visas and travel insurance, we handle all the logistics so you can focus on enjoying your journey. "
        conclusion="With KhmerGate, traveling abroad has never been easier. Wherever your heart desires to go, we're here to take you there. "
        imagePosition="left"
        buttonHoverColor="#927b49"
        buttoncolor="#ff6b18"
        textColor="#015B02"
      />
      <div className="h-[2px] w-3/4 bg-black"></div>
      <DetailCard
        image={mic_img}
        topicTop="Event Management and MICE"
        topicBottom="Turning Your Events into Experiences"
        description="At KhmerGate, we don't just create travel experiences; we bring your dreams to life through our professional Event Management and MICE (Meetings, Incentives, Conferences, and Exhibitions) services. Whether you're planning a corporate retreat, a grand conference, or an intimate destination wedding, we ensure that every detail is meticulously managed to perfection."
        subTopic="Our Event Management Services Include : "
        subPoint1="Corporate Events & Team Building: "
        subPointDes1="From incentive programs to high-level conferences, we manage everything from venue selection to travel arrangements, ensuring a successful event. "
        subPoint2="Destination Weddings :"
        subPointDes2="Celebrate your love in a magical setting with full-service wedding planning that handles everything from guest accommodations to exotic wedding venues."
        subPoint3="Custom Celebrations : "
        subPointDes3="Whether it's a family reunion or a special celebration, we create bespoke events designed to leave lasting impressions."
        conclusion="Let us take the stress out of event planning, so you can focus on what truly matters: enjoying the moment."
        imagePosition="right"
        buttonHoverColor="#927b49"
        buttoncolor="#ff6b18"
        textColor="#015B02"
      />
      <div className="h-[2px] w-3/4 bg-black"></div>
      <DetailCard
        image={thai_girl}
        topicTop="Special Interest Tours:"
        topicBottom="Travel with Purpose"
        description="At KhmerGate, we recognize that every traveler has unique passions and interests. That's why we offer Special Interest Tours that go beyond traditional travel experiences, allowing you to dive deep into what excites you most. Whether you're a foodie, a photography enthusiast, or seeking spiritual renewal, our tours are designed to help you explore your passions in new and exciting ways."
        subTopic="Our Special Interest Tours Include:"
        subPoint1="Culinary Journeys:"
        subPointDes1="Savor the flavors of Cambodia with cooking classes, food tours, and visits to local markets, where you can sample traditional dishes and meet the chefs behind them."
        subPoint2="Photography Expeditions:"
        subPointDes2="Capture Cambodia's stunning landscapes and iconic sites with guided photography tours, perfect for both amateur and professional photographers."
        subPoint3="Spiritual Retreats:"
        subPointDes3="Find peace and renewal with spiritual tours that take you to Cambodia's most serene temples and meditation centers."
        conclusion="Whatever your interest, KhmerGate's special interest tours provide a deeper, more meaningful connection to the world around you."
        imagePosition="left"
        buttonHoverColor="#927b49"
        buttoncolor="#ff6b18"
        textColor="#015B02"
      />
      <div className="h-[2px] w-3/4 bg-black"></div>
      <DetailCard
        image={couple}
        topicTop="Custom Travel Solutions : "
        topicBottom="Tailored Just for You"
        description="At KhmerGate, we understand that every traveler is unique, and so are their journeys. That's why we offer Custom Travel Solutions designed to meet your specific preferences and needs. Whether you're planning a family vacation, a solo adventure, or a corporate retreat, our team will work with you to create a personalized itinerary that reflects your interests, budget, and travel goals."
        subTopic="Our Custom Travel Solutions Include:"
        subPoint1="Personalized Itineraries:"
        subPointDes1="Each trip is tailor-made to suit your schedule, interests, and preferences, ensuring a unique experience that's designed just for you."
        subPoint2="Exclusive Access:"
        subPointDes2="Get access to off-the-beaten-path experiences, private tours, and exclusive locations that offer a deeper connection to the destination."
        subPoint3="Hassle-Free Planning:"
        subPointDes3="From transportation and accommodation to dining and excursions, we take care of every detail, ensuring a smooth and stress-free journey."
        conclusion="Whether you're looking for adventure, relaxation, or a bit of both, KhmerGate's Custom Travel Solutions ensure that every aspect of your trip is tailored to provide you with the journey of your dreams."
        imagePosition="right"
        buttonHoverColor="#927b49"
        buttoncolor="#ff6b18"
        textColor="#015B02"
      />
      <div className="h-[2px] w-3/4 bg-black"></div>
    </div>
  );
};

export default KhmergateFifth;
